import { TLC_CONSTANTS } from "../../../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../../../js/lib/ext/Ext";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { AvailabilityClientManager } from "../../../ClientManagers/AvailabilityClientManager";
import { LS2PAC_Utils } from "../../../utils/Utils";
import { LibraryThing } from "../../../widget/LibraryThingWidget";
import { BaseResultTypeView } from "./BaseResultTypeView";
import { RateAndReview } from "../../../../../../js/lib/components/RateAndReview";
import { renderInShadow } from "../../../../../../js/lib/components/ShadowUtils";
import { ApplicationData } from "../../../ApplicationData";
import * as React from 'react';

export class FlowView extends BaseResultTypeView {
  constructor(options) {
    options = options || {};

    options.availabilityTemplate = "tmpl/results/listView_availability.html";
    options.resultsTemplate = "tmpl/results/flowView_Results.html";
    options.viewName = "flowView";
    options.fetchAvailabilityOnSearchResults = false;

    options.availabilitySuffix =
      "_flowView" + LS2PAC_CONSTANTS.Ids.SearchPage.availabilitySuffix;
    options.footerControlsSuffix =
      "flowView_" + LS2PAC_CONSTANTS.Ids.SearchPage.footerControlsSuffix;
    options.resultItemCallAndCollSuffix =
      "_flowView" + LS2PAC_CONSTANTS.Ids.SearchPage.resultItemCallAndColl;

    super(options);
    this.pageHash = {};
    this.pageKey = "page_";
    this.currentResource;
    this.currentIndex;
    this.reloadForDBChange = false;

    var flowItemTemplate =
      '<li class="clearfix" id="result_resource_{id}">' +
      '<a href="{href}" class="bookjacketLink flowViewClick clearfix" ' +
      'data-index="{index}" data-totalIndex="{totalIndex}" data-page="{resultPageNumber}">' +
      '<div class="imgContainer"><div id="{id}_bookJacket" class="bookjacket" data-index="{index}" data-resourceId="{id}"></div></div>' +
      "</a></li>";

    this.resultItemExt = TLCEXT.Template(flowItemTemplate);
    this.removeListenerFunctions = [];
    this.addListeners();
    this.addExtraListeners();

    this.waitingForSummary = false;
    this.callHandleAfterAnimation = false;
  }
  reset() {
    $("#" + this.id).empty();
    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent).empty();
    this.spin();
    this.resources = [];
    this.pageHash = {};
    this.currentResource = undefined;
    this.currentIndex = undefined;
    this.currentPage = undefined;
    this.realIndex = undefined;
    var currentOne = $(
      "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent
    ).find("." + LS2PAC_CONSTANTS.CssClasses.current);
    if (currentOne.length > 0) {
      currentOne.fadeOut(400, function () {
        currentOne.css("left", -1000);
        currentOne.show();
        currentOne.removeClass(LS2PAC_CONSTANTS.CssClasses.current);
      });
    }
    $("#" + this.id).css("left", 0);
  }
  updatePageHash(page) {
    this.pageHash[this.pageKey + page.currentPage] = page;
  }
  getCurrentResultPage() {
    return this.pageHash[this.pageKey + this.currentPage];
  }
  loadResults(event, onChangeViewEvent) {
    var _this = this;

    this.updatePageHash(event.data);

    this.searchResponse = event.data;

    if (this.isCurrentResultTypeView()) {
      if (onChangeViewEvent || this.reloadForDBChange) {
        this.reloadForDBChange = false;
        this.reset();
        TLCEventManager.fireEvent(
          TLC_CONSTANTS.Events.onClickSkipToResultPage,
          { pageNum: 1 }
        );
      } else {
        if (event.success) {
          $.each(event.data.resources, function (index, resource) {
            if (
              $(
                "#" +
                  LS2PAC_CONSTANTS.Ids.SearchPage.result_resource_prefix +
                  resource.id
              ).length == 0
            ) {
              _this.resources.push(resource);

              if (_this.currentResource == undefined) {
                _this.currentIndex = 0;
                _this.currentPage = 1;
                _this.realIndex = 0;
                _this.currentResource = resource;

                setTimeout(function () {
                  _this.changeFlowViewResource();
                }, 10);
              }

              if (_this.currentIndex != undefined) {
                _this.currentResource = _this.resources[_this.currentIndex];
              }

              resource.index = index;
              resource.totalIndex = _this.resources.length - 1;
              resource.resultPageNumber = _this.searchResponse.currentPage;
              resource.href =
                "/" + location.hash + "?__flowItem=" + resource.id;
              _this.resultItemExt.append($("#" + _this.id), resource);
              $(
                "#" +
                resource.id + 
                LS2PAC_CONSTANTS.Ids.SearchPage.bookJacketSuffix
              ).addCoverArt(
                LibraryThing.enums.requestType.bookJacketSmall,
                _this.resources,
                resource.totalIndex,
                true
              );
            }
          });

          if (
            $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).is(
              ":visible"
            ) == false
          ) {
            $(
              "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer
            ).show();
          }
        } else {
          $("#" + this.id).empty();
        }
      }
    }
  }
  initSummary() {
    var summaryContainer = this.getSummaryContainer();
    summaryContainer.empty();
    var selector =
      "#" +
      LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemSuffix +
      this.currentResource.id +
      " blockquote.multiline";

    LibraryThing.addEnrichment(
      summaryContainer,
      LibraryThing.enums.enrichments.summary
    );
    this.refreshSU(selector, this.currentResource);
  }
  changeFlowViewResource(fromClick, direction) {
    var _this = this;

    TemplateEngine.fetch(
      "tmpl/results/flowView_selectedItem.html",
      LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent,
      _this.currentResource,
      () => {
        $(
          "#" +
          LS2PAC_CONSTANTS.Ids.FlowViewPage.bookJacketSuffix +
            _this.currentResource.id
            
        ).addCoverArt(
          LibraryThing.enums.requestType.bookJacketLarge,
          [_this.currentResource],
          0,
          true,
          false,
          function () {
            _this.animate(fromClick, direction);
          },
          false
        );

        if (parseInt(_this.currentResource.rtype, 10) == 1) {
          if (window.isIE8 == false) {
            $("#" + _this.currentResource.id + _this.availabilitySuffix).spin(
              "tiny"
            );
          }
          AvailabilityClientManager.getItemAvailability(
            [_this.currentResource],
            function (resources, wentToServer, success) {
              _this.renderAvailability([_this.currentResource], success);
            }
          );

          const { resourceId, average, onClickReview } =
            LS2PAC_Utils.getRatingsConfiguration(this.currentResource);
          const container = document.querySelector(
            "#" +
            LS2PAC_CONSTANTS.Ids.SearchPage.flowViewRatings +
              _this.currentResource.id 
              
          );
          renderInShadow(
            <RateAndReview
              resourceId={resourceId}
              averageRating={average}
              onClickReview={onClickReview}
            ></RateAndReview>,
            container,
            ApplicationData.language
          );


        }

        if (LibraryThing.hasSummary()) {
          _this.waitingForSummary = true;
          _this.initSummary();
        } else {
          _this.waitingForSummary = false;
        }
      }
    );
  }
  refreshSU(selector, metaData) {
    var _this = this;
    var retryCallback = function () {
      _this.refreshSU(selector, metaData);
    };

    $.when(
      LibraryThing.refreshMetaData(
        selector,
        _this.currentResource,
        retryCallback
      )
    ).always(function () {
      _this.waitingForSummary = false;

      /*
       * This is admittedly a little nuts.  What happens is that if this logic runs during the quick info
       * animations it will be chunky and crappy looking.  To avoid this we have to wait until one of the many
       * possible anitmation types are finished ... thanks designers d_(>_<)_b  <= sarcastic double thumbs up squint face...  anyway its also possible that the call
       * to fetch the summary takes even longer than it does to animate in... so we have a fun race condition to
       * run this logic.  this will be triggered if its tried to run the logic post animation but we haven't
       * recieved the summary yet.
       */
      if (_this.callHandleAfterAnimation) {
        _this.handleAfterAnimation();
        _this.callHandleAfterAnimation = false;
      }
    });
  }
  getSummaryContainer() {
    return $(
      "#" +
      LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemSuffix +
        this.currentResource.id
        
    ).find("blockquote.multiline");
  }
  animate(fromClick, direction) {
    if (this.isAnimating == true) {
      return;
    }
    var _this = this,
      windowWidth = $(
        "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent
      ).width();

    this.isAnimating = true;

    var distance;
    direction = direction || 1;

    var currentOne = $(
      "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent
    ).find("." + LS2PAC_CONSTANTS.CssClasses.current);
    if (currentOne.length > 0) {
      var showingItemsIndex = parseInt(currentOne.attr("data-index"), 10);

      if (isNaN(showingItemsIndex)) {
        direction = 1;
      } else {
        direction = showingItemsIndex < _this.currentIndex ? 1 : -1;
      }
    }
    distance = windowWidth * direction;

    $("#" + _this.id)
      .find("a.flowViewClick")
      .each(function (index, link) {
        $(link).removeClass(LS2PAC_CONSTANTS.CssClasses.active);
      });

    var currentInFilmStrip = $("#" + _this.id).find(
      "a.flowViewClick:eq(" + _this.currentIndex + ")"
    );

    currentInFilmStrip.addClass(LS2PAC_CONSTANTS.CssClasses.active);

    var stripWidth = Math.floor(
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.scrollContainer).width() / 2
    );
    //var scrollerWidth = $("#"+_this.id).width();
    var leftEdge =
      Math.floor(
        currentInFilmStrip.offset().left - $("#" + _this.id).offset().left
      ) + Math.floor(currentInFilmStrip.width());

    var leftSpot = 0;
    if (leftEdge > stripWidth) {
      leftSpot = stripWidth - leftEdge;
    }
    $("#" + _this.id).animate({ left: leftSpot }, 200);

    var itemToAnimateIn = $(
      "#" +
      LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemSuffix +
        this.currentResource.id 
        
    );
    if (
      itemToAnimateIn.hasClass(LS2PAC_CONSTANTS.CssClasses.current) == false
    ) {
      itemToAnimateIn.css("left", distance + "px");
      itemToAnimateIn.css({ opacity: 0 });

      if (currentOne.length == 1) {
        currentOne = $(currentOne);
        currentOne.animate(
          { left: distance * -1, opacity: 0 },
          600,
          "easeOutQuad",
          function () {
            currentOne.removeClass(LS2PAC_CONSTANTS.CssClasses.current);
          }
        );
      }

      itemToAnimateIn.animate(
        { left: 0, opacity: 1 },
        600,
        "easeOutQuad",
        function (event) {
          itemToAnimateIn.addClass(LS2PAC_CONSTANTS.CssClasses.current);
          _this.updatePagingControls();
          _this.isAnimating = false;
          _this.handleAfterAnimation();
          _this.updateContainerHeight();
          if (_this.currentIndex + 6 >= _this.resources.length) {
            _this.getNextPage();
          }
        }
      );
    } else {
      _this.isAnimating = false;
    }
  }
  updateContainerHeight() {
    var container = $(
      "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent
    );
    var containerHeight = container
      .find("." + LS2PAC_CONSTANTS.CssClasses.current)
      .height();
    var bookjacketHeight = $(
      "#" +
      LS2PAC_CONSTANTS.Ids.FlowViewPage.bookJacketSuffix +
        this.currentResource.id
        
    )
      .find("img")
      .height();
    var heightToUse = containerHeight;

    if (bookjacketHeight > containerHeight) {
      heightToUse = bookjacketHeight;
    }
    container.css("height", heightToUse);
  }
  spin() {
    if (window.isIE8 == false) {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent).spin(
        "large"
      );
    }
  }
  changeFlowViewResourceClick() {
    var _this = this;

    return function (event) {
      _this.spin();
      _this.updateCurrentData($(event.currentTarget));

      if (
        $(
          "#" +
          LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemSuffix +
            _this.currentResource.id
            
        ).length == 0
      ) {
        _this.changeFlowViewResource(true);
      } else {
        _this.animate(true, 1);
      }

      return false;
    };
  }
  updateCurrentData(element) {
    //this is its index in the page results
    this.realIndex = parseInt(element.attr("data-index"), 10);

    //this is the index across all pages
    this.currentIndex = parseInt(element.attr("data-totalIndex"), 10);

    this.currentPage = parseInt(element.attr("data-page"), 10);

    this.currentResource =
      this.getCurrentResultPage().resources[this.realIndex];
  }
  handleArrowClick(direction) {
    this.spin();
    this.currentIndex += direction;

    if (this.currentIndex == this.resources.length) {
      this.getNextPage();
    } else {
      this.currentResource = this.resources[this.currentIndex];

      //find whats going to be the selected item
      this.updateCurrentData(
        $(
          "#" +
            LS2PAC_CONSTANTS.Ids.SearchPage.result_resource_prefix +
            this.currentResource.id
        ).find(".flowViewClick")
      );

      if (
        $(
          "#" +
          LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemSuffix +
            this.currentResource.id
            
        ).length == 0
      ) {
        this.changeFlowViewResource(true, direction);
      } else {
        this.animate(true, direction);
      }
    }
  }
  getNextPage() {
    if (this.searchResponse.currentPage < this.searchResponse.totalPages) {
      this.isWaitingForResponse = true;
      TLCEventManager.fireEvent(TLC_CONSTANTS.Events.onClickNextResultPage, {
        noHistory: true,
      });
    }
  }
  handleKeyDown(e) {
    if (this.isCurrentResultTypeView()) {
      if (e.keyCode == 37 /* left arrow key */) {
        $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewPrev).trigger("click");
      } else if (e.keyCode == 39 /* right arrow key */) {
        $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewNext).trigger("click");
      }
    }
  }
  addEvents() {
    if (this.hasBoundEvents === false) {
      var _this = this;

      $("#" + this.id).on(
        "click",
        "a.flowViewClick",
        this.changeFlowViewResourceClick()
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "." +
          LS2PAC_CONSTANTS.CssClasses.copies +
          ", ." +
          LS2PAC_CONSTANTS.CssClasses.availabilityBindClass,
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resourceData: _this.getCurrentResultPage(),
            index: _this.realIndex,
            viewName: LS2PAC_CONSTANTS.DetailPages.allCopies,
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.fullDetails,
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resourceData: _this.getCurrentResultPage(),
            index: _this.realIndex,
          });
          event.stopPropagation();
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.reviews,
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resourceData: _this.getCurrentResultPage(),
            index: _this.realIndex,
            viewName: LS2PAC_CONSTANTS.DetailPages.reviews,
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.moreSummary,
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resourceData: _this.getCurrentResultPage(),
            index: _this.realIndex,
            viewName: LS2PAC_CONSTANTS.DetailPages.lookInside,
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewNext,
        function (event) {
          $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
          _this.handleArrowClick(1);
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewPrev,
        function (event) {
          $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
          _this.handleArrowClick(-1);
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        ".request",
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRequest, {
            resource: _this.currentResource,
            referrer: "FlowView",
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).on(
        "click",
        ".eResource",
        function (event) {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
            { resource: _this.currentResource, referrer: "FlowView" }
          );
          return false;
        }
      );

      this.handleKeyDown = this.handleKeyDown.bind(this);
      $(document).on("keydown", this.handleKeyDown);

      // if ($("html").hasClass("touch")) {
      //   $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent).swipe({
      //     swipeLeft: function (event) {
      //       //tlc.debug.log("SWIPE", event);
      //       //if the orientation is 90 then its held in landscape 'right side up'
      //       //if its -90 then the ipad is 'upside down' so we have to flip the direction
      //       var direction = window.orientation > 0 ? 1 : -1;
      //       _this.handleArrowClick(1);
      //     },
      //     swipeRight: function (event) {
      //       //tlc.debug.log("SWIPE", event);
      //       //if the orientation is 90 then its held in landscape 'right side up'
      //       //if its -90 then the ipad is 'upside down' so we have to flip the direction
      //       var direction = window.orientation > 0 ? -1 : 1;
      //       _this.handleArrowClick(-1);
      //     },
      //     allowPageScroll: "auto",
      //   });
      // }

      this.hasBoundEvents = true;
    }
  }
  removeEvents(){
    
    $("#" + this.id).off(
      "click",
      "a.flowViewClick");

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "." +
        LS2PAC_CONSTANTS.CssClasses.copies +
        ", ." +
        LS2PAC_CONSTANTS.CssClasses.availabilityBindClass);

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "." + LS2PAC_CONSTANTS.CssClasses.fullDetails,
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "." + LS2PAC_CONSTANTS.CssClasses.reviews,
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "." + LS2PAC_CONSTANTS.CssClasses.moreSummary,
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewNext,
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      "#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewPrev,
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      ".request",
    );

    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).off(
      "click",
      ".eResource",
    );

    $(document).off("keydown", this.handleKeyDown);
    this.hasBoundEvents = false;
  }
  updatePagingControls() {
    if (this.currentIndex == 0) {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewPrev).addClass(
        LS2PAC_CONSTANTS.CssClasses.disabled
      );
    } else {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewPrev).removeClass(
        LS2PAC_CONSTANTS.CssClasses.disabled
      );
    }
    if (
      this.searchResponse.currentPage == this.searchResponse.totalPages &&
      this.currentIndex == this.resources.length - 1
    ) {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewNext).addClass(
        LS2PAC_CONSTANTS.CssClasses.disabled
      );
    } else {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewNext).removeClass(
        LS2PAC_CONSTANTS.CssClasses.disabled
      );
    }
  }
  handleAfterAnimation() {
    $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContent).spin(false);
    var _this = this;
    if ($(document.body).hasClass("flowView")) {
      if (this.waitingForSummary === false) {
        // LS2PAC_Utils.adjustSummaryContent( this.currentResource, this.getSummaryContainer() );
        _this.updateContainerHeight();
      } else {
        this.callHandleAfterAnimation = true;
      }
    }
  }

  addListener(handle, callback) {
    const guid = TLCEventManager.addListener(handle, callback);
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(handle, guid));
  }

  addExtraListeners() {
    var _this = this;

    const resetFunction = function () {
      _this.reset();
    }
    this.addListener(LS2PAC_CONSTANTS.Events.onSearch, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onChangeBranchLimits, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onAddFacetFilterToResults, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onRemoveFacetFilter, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onSortSearch, resetFunction);
    this.addListener(LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase, function (event) {
      if (_this.isCurrent()) {
        _this.reloadForDBChange = true;
      }
    });
  }

  removeExtraListeners(){
    this.removeListenerFunctions.forEach((remove) => remove());
  }
  cleanup(){
    this.removeEvents();
    this.removeExtraListeners();
  }
}
